import type { SVGProps } from 'react'

export const CloudUploadOutlinedIcon = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="m450-471.39-53.31 52.7q-8.21 8.3-20.53 8.3-12.31 0-21.24-8.92-8.69-8.31-8.5-21.07.2-12.77 8.5-21.08l99.77-99.77q10.85-10.85 25.31-10.85 14.46 0 25.31 10.85l99.77 99.77q8.3 8.31 8.8 20.73t-8.8 21.45q-8.31 8.28-20.77 8.39-12.46.12-21.39-8.19L510-471.39v219.08q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85H740q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-83-58.5-141.5T480-720q-83 0-141.5 58.5T280-520h-20.77q-56.85 0-98.04 41Q120-438 120-380t41 99q41 41 99 41h70q12.75 0 21.38 8.63 8.62 8.63 8.62 21.38 0 12.76-8.62 21.37Q342.75-180 330-180h-70q-82.92 0-141.46-57.53Q60-295.06 60-378.15q0-74.54 47.96-131.12t118.96-67.04Q246.15-666 317.12-723q70.96-57 162.88-57 108.64 0 184.32 75.68Q740-628.64 740-520v20h12.31q63.23 4.92 105.46 50.85Q900-403.23 900-340q0 66.92-46.15 113.46Q807.69-180 740.77-180H522.31Q492-180 471-201q-21-21-21-51.31v-219.08ZM480-450Z" />
    </svg>
  )
}
